import html2canvas from 'html2canvas';
import { jsPDF as JSPDF } from 'jspdf';

const setBoxShadowNone = (element) => {
  // eslint-disable-next-line no-param-reassign
  element.style.boxShadow = 'none';
  for (let i = 0; i < element.children.length; i += 1) {
    setBoxShadowNone(element.children[i]);
  }
};

function findNearestWhitespaceRow(canvas, yStart, minWhiteRatio = 1.0, scanHeight = 40) {
  const ctx = canvas.getContext('2d');
  const { width } = canvas;
  for (let y = yStart; y > Math.max(0, yStart - scanHeight); y -= 1) {
    const imageData = ctx.getImageData(0, y, width, 1).data;
    let whitePixels = 0;
    for (let x = 0; x < width; x += 1) {
      const r = imageData[x * 4];
      const g = imageData[x * 4 + 1];
      const b = imageData[x * 4 + 2];
      if (r > 200 && g > 200 && b > 200) {
        whitePixels += 1;
      }
    }
    if (whitePixels / width >= minWhiteRatio) {
      return y;
    }
  }
  return yStart;
}

const handlePdfExport = (sectionRefs, fileName) => {
  const pdf = new JSPDF({ unit: 'pt', format: 'a4', orientation: 'landscape' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const verticalMargin = 20;
  const filteredSectionRefs = sectionRefs.filter(({ include }) => include);

  const processSection = (i) => {
    if (i >= filteredSectionRefs.length) {
      pdf.save(`${fileName}.pdf`);
      return;
    }
    const { ref } = filteredSectionRefs[i];
    if (!ref.current) {
      processSection(i + 1);
    }
    const clone = ref.current.cloneNode(true);
    setBoxShadowNone(clone);
    clone.style.width = '1200px';
    clone.style.maxWidth = '1200px';
    clone.style.overflow = 'visible';
    document.body.appendChild(clone);
    html2canvas(clone, { scale: 2 }).then((canvas) => {
      document.body.removeChild(clone);
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const widthScale = pageWidth / imgWidth;
      const scale = Math.min(widthScale, 1);
      const renderWidth = imgWidth * scale;
      const renderHeight = imgHeight * scale;
      const availablePgHeight = pageHeight - 2 * verticalMargin;

      // If section fits onto a single page add it, otherwise split into multiple pages.
      if (renderHeight <= availablePgHeight) {
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const x = (pageWidth - renderWidth) / 2;
        pdf.addImage(imgData, 'JPEG', x, verticalMargin, renderWidth, renderHeight);
        if (i < filteredSectionRefs.length - 1) pdf.addPage();
        processSection(i + 1);
      } else {
        let pageOffset = 0;
        while (pageOffset < imgHeight) {
          let sliceHeight = Math.min(imgHeight - pageOffset, availablePgHeight / scale);
          const sliceEnd = pageOffset + sliceHeight;
          const safeSliceEnd = findNearestWhitespaceRow(canvas, sliceEnd - 1);
          sliceHeight = safeSliceEnd - pageOffset;

          if (sliceHeight > 0) {
            const sliceCanvas = document.createElement('canvas');
            sliceCanvas.width = imgWidth;
            sliceCanvas.height = sliceHeight;
            const ctx = sliceCanvas.getContext('2d');
            ctx.drawImage(
              canvas,
              0,
              pageOffset,
              imgWidth,
              sliceHeight,
              0,
              0,
              imgWidth,
              sliceHeight,
            );
            const imgData = sliceCanvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(
              imgData,
              'JPEG',
              (pageWidth - renderWidth) / 2,
              verticalMargin,
              renderWidth,
              sliceHeight * scale,
            );
            pageOffset += sliceHeight;
            if (pageOffset < imgHeight - 1) pdf.addPage();
          } else {
            pageOffset += 1;
          }
        }
        if (i < filteredSectionRefs.length - 1) pdf.addPage();
        processSection(i + 1);
      }
    });
  };

  processSection(0);
};

export default handlePdfExport;
